import { useQuery } from "@tanstack/react-query";

import { getStorefrontCollections } from "../services/frontend/storefront-apis";

/** Normalize the storefront collection title, handle and id for chips / side nav. */
const normalizeCollections = (data) => ({
  collections: (data?.collections || []).map((c) => ({
    _id: c.id,
    id: c.id,
    title: c.title,
    handle: c.handle || null,
  })),
});

const useStorefrontCollections = () => {
  return useQuery({
    queryKey: ["storefrontCollections"],
    queryFn: async () => {
      const data = await getStorefrontCollections();
      return normalizeCollections(data);
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
  });
};

export default useStorefrontCollections;
